module.exports = "/_next/static/images/ca54a1d771174f783e0e70b012695f80-card-background-left-xs.jpg";